import React from "react";
import Diary from "./components/Diary";
import WorkDiaryWrapper from "./components/style";

const WorkDiary = (props) => {
  const { activeRecord, currentDate, type } = props;
  return (
    <WorkDiaryWrapper>
      <div className="outer">
        <div className="inner">
          <div id="work_diary" className="pdf" dir="rtl">
            <Diary
              activeRecord={activeRecord}
              currentDate={currentDate}
              type={type}
            />
          </div>
        </div>
      </div>
    </WorkDiaryWrapper>
  );
};

export default WorkDiary;
